export default {
    update: "Обновить",
    title: "Обновления",
    columns: {
        name: "Сервис",
        version: "Версия",
        download: "Дата скачивания",
        send_request_download: "Внеочередная проверка обновлений",
        send_request_delete: "Удалить все сервисы",
    },
    notification: {
        load_error: "Ошибка загрузки",
        download_ok: "Запрос успешно отправлен",
        download_error: "Ошибка запроса",
    },
}